import { render, staticRenderFns } from "./Vo2.vue?vue&type=template&id=ed217ab6&scoped=true&"
import script from "./Vo2.vue?vue&type=script&lang=js&"
export * from "./Vo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed217ab6",
  null
  
)

export default component.exports